import type { SVGProps } from "react";
const SvgConversation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7 6V5c0-1.414 0-2.121.44-2.56C7.878 2 8.585 2 10 2h4c1.414 0 2.121 0 2.56.44C17 2.878 17 3.585 17 5v1c0 1.414 0 2.121-.44 2.56C16.122 9 15.415 9 14 9h-1l-3 2V9c-1.414 0-2.121 0-2.56-.44C7 8.122 7 7.415 7 6Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M3.59 18.74c-.629.422-2.277 1.282-1.273 2.358.49.526 1.037.902 1.723.902h3.92c.686 0 1.233-.376 1.723-.902 1.004-1.076-.644-1.936-1.273-2.357a4.29 4.29 0 0 0-4.82 0ZM15.59 18.74c-.629.422-2.277 1.282-1.273 2.358.49.526 1.037.902 1.723.902h3.92c.686 0 1.233-.376 1.723-.902 1.004-1.076-.644-1.936-1.273-2.357a4.29 4.29 0 0 0-4.82 0ZM8 13.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM20 13.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
    />
  </svg>
);
export default SvgConversation;
